import {
    createContext,
    ReactNode,
    useCallback,
    useMemo,
    useState,
} from "react";

const initialState: {
    pageContext: Record<string, unknown>,
    updatePageContext: (context: Record<string, unknown>) => void, // eslint-disable-line
} = {
    pageContext: {},
    updatePageContext: () => null,
};

export const AlfredAgentProviderContext = createContext(initialState);

export const AlfredAgentProvider = ({ children }: { children: ReactNode }) => {
    const [pageContext, setPageContext] = useState<Record<string, unknown>>({});

    const updatePageContext = useCallback(
        (context: Record<string, unknown>) => {
            setPageContext(context);
        },
        [],
    );

    const contextValue = useMemo(
        () => ({
            pageContext,
            updatePageContext,
        }),
        [pageContext, updatePageContext],
    );

    return (
        <AlfredAgentProviderContext.Provider value={contextValue}>
            {children}
        </AlfredAgentProviderContext.Provider>
    );
};
